import React, { forwardRef } from 'react';
import type { TabScrollButtonProps } from '@mui/material';
import { TabScrollButton as TabScrollButtonMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

const TabScrollButton = forwardRef<HTMLButtonElement, TabScrollButtonProps>(
  ({ direction, orientation, ...props }, ref) => (
    <TabScrollButtonMUI direction={direction} orientation={orientation} {...omitUndefinedProps(props)} ref={ref} />
  ),
);

TabScrollButton.displayName = 'TabScrollButton';

export default TabScrollButton;
